export const FORM_TEMPLATE_TYPES = {
  GATED_FLOW_NAME: 'carvana_gated_flow_name',
  RATING_REQUEST: 'carvana_rating_request_form',
  RATING_CONTACT_FOLLOW_UP_CHALLENGE: 'carvana_contact_followup_challenge_form',
  RATING_CONTACT_FOLLOW_UP: 'carvana_contact_followup_question_form',
  RATING_CONTACT_FOLLOW_UP_TEXT_ONLY: 'carvana_contact_followup_text_only_question_form',
  FEEDBACK_REQUEST: 'carvana_feedback_request_form',
  CONTACT_FOLLOW_UP_CHAT_ONLY: 'carvana_contact_followup_chat_only_question_form',

  // This form is currently not in use. Defining here to avoid crashing the app when encountering
  LEAD_GEN_FORM: 'carvana_lead_gen',
};
